import { GetEvent } from "../controllers/company/EventsController";
import { url } from "./apiBase";

const adminUrl = url + 'supera/';

const SuperAdminRoutes = {
    Subscriptions:{
        Plans:{
            List: adminUrl + 'plans',
            Store: adminUrl + 'plans'
        }
    }
}

export default SuperAdminRoutes;